import { customFetch,CustomFetchError } from "@/client/custom-fetch";

import type { TProductJourneyConfigPayload } from "./journey-config.types";

export type TProductJourneyConfigResponse = {
  id: string;
  product_id: string;
  config: TProductJourneyConfigPayload;
  created_at: string;
  updated_at: string;
};

const BASE = "/product-journey-configs";

export async function getProductJourneyConfigByProductId(
  productId: string,
): Promise<TProductJourneyConfigResponse | null> {
  try {
    return await customFetch<TProductJourneyConfigResponse>(
      `${BASE}/by-product/${productId}`,
    );
  } catch (e) {
    if (e instanceof CustomFetchError && e.status === 404) {
      return null;
    }
    throw e;
  }
}

export async function createProductJourneyConfig(
  productId: string,
  config: TProductJourneyConfigPayload,
): Promise<TProductJourneyConfigResponse> {
  return customFetch<TProductJourneyConfigResponse>(BASE, {
    method: "POST",
    body: JSON.stringify({ product_id: productId, config }),
  });
}

export async function updateProductJourneyConfig(
  journeyConfigId: string,
  config: TProductJourneyConfigPayload,
): Promise<TProductJourneyConfigResponse> {
  return customFetch<TProductJourneyConfigResponse>(
    `${BASE}/${journeyConfigId}`,
    {
      method: "PATCH",
      body: JSON.stringify({ config }),
    },
  );
}
